<ng-container *ngrxLet="timeDiffData$; let timeRangeData">
    <ng-container *ngIf="timeRangeData.days"> {{ "dtmUi.timeLabels.days" | transloco : { days: timeRangeData.days } }}&nbsp; </ng-container>
    <ng-container *ngIf="timeRangeData.hours">
        {{ "dtmUi.timeLabels.hours" | transloco : { hours: timeRangeData.hours } }}&nbsp;
    </ng-container>
    <ng-container *ngIf="timeRangeData.minutes">
        {{ "dtmUi.timeLabels.minutes" | transloco : { minutes: timeRangeData.minutes } }}
    </ng-container>
</ng-container>
